export enum JobExceptionType {
  Validation = 'VALIDATION',
}
